// extracted by mini-css-extract-plugin
module.exports = {"root":"root_21y1K","container":"container_3ZW-g","headLine":"headLine_sKVBu","subHeadLine":"subHeadLine_1qXEI","text":"text_g2eSB"};